module.exports = __webpack_public_path__ + "img/流体力学1_7.0729a7fa.jpg";